import { combineReducers } from 'redux';

import { reducer as authReducer } from './auth';
import { reducer as translateReducer } from './translate';
import { reducer as CveReducer } from './cve';
import { reducer as reportUsers } from './users';
import filterReducer from './filters';
import capabilitiesReducer from './capabilities';
import contextReducer from './context';

// Combine all reducers.

const rootReducer = combineReducers({
  auth: authReducer,
  user: reportUsers,
  translate: translateReducer,
  cve: CveReducer,
  filters: filterReducer,
  capabilities: capabilitiesReducer,
  context: contextReducer
});

export default rootReducer;
